<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div v-if="setting_type_food == 0">
            <div v-for="(buffet_detail,key) in buffet_list" :key="key">
                <v-card class="mb-5" v-if="buffet_detail.menuList.length > 0">
                    <h3 class="pa-3">
                        {{ locale == 'en' ? buffet_detail.nameEng : buffet_detail.name  }}
                    </h3>
                    <div v-for="(food_detail,key_detail) in buffet_detail.menuList" :key="key_detail">
                        <div class="mb-2 pa-3" v-if="food_detail.status == 1">
                            <div class="cursor_type_buffet" @click="openDetail(food_detail.id)">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <div>{{ locale == 'en' ? food_detail.nameEng : food_detail.name }}</div>
                                            <div class="description_type_buffet">
                                                {{ food_detail.sub_title }}
                                            </div>
                                        </div>
                                        <div>{{ Intl.NumberFormat().format(food_detail.price_buffet) }} ฿</div>
                                    </div>
                                    <div class="img_type_buffet">
                                        <img :src="food_detail.picture">
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="key_detail != Object.keys(buffet_detail.menuList).length - 1"></v-divider>
                        </div>
                        <div class="mb-2 pa-3" style="background:#eee" v-if="food_detail.status == 0">
                            <div class="cursor_type_buffet">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <h4 class="itemout_type_buffet">ขออภัยสินค้าหมด</h4>
                                            <div>{{ locale == 'en' ? food_detail.nameEng : food_detail.name }} <span class="description_type_buffet">( {{ locale == 'en' ? food_detail.nameEng : food_detail.name }} )</span></div>
                                            <div class="description_type_buffet">
                                                {{ food_detail.sub_title }}
                                            </div>
                                        </div>

                                        <div>{{ Intl.NumberFormat().format(food_detail.price_buffet) }} ฿</div>
                                    </div>

                                    <div class="img_type_buffet">
                                        <img :src="food_detail.picture">
                                        <div class="img_sole_type_buffet">
                                            <img src="@/assets/soulout.png">
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <v-divider v-if="key_detail != Object.keys(buffet_detail.menuList).length - 1"></v-divider>
                        </div>
                    </div>

                </v-card>
            </div>
        </div>
        <div v-if="setting_type_food == 1">
            <v-container v-if="!buffet_id">
                <v-row>
                    <!-- <v-col cols="12">
                        <v-text-field label="ค้นหาเมนูอาหาร" v-model="search" @keyup="searchMenu()" :color="border_color" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="!search"> -->
                    <v-col cols="6" v-for="(buffet_detail,key_food) in buffet_list" :key="key_food">
                        <div class="cursor_type_buffet" @click="buffetSelectPage(buffet_detail.id)">
                            <div class="cover_image_type_buffet">
                                <img :src="buffet_detail.cover_image">
                            </div>
                            <div class="text-center">{{ locale == 'en' ? buffet_detail.nameEng : buffet_detail.name  }}</div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <div v-if="search">
                <v-card class="mb-5">
                    <div v-for="(food_search_detail,key_search_detail) in buffet_search_list" :key="key_search_detail">
                        <div class="mb-2 pa-3" v-if="food_search_detail.status == 1">
                            <div class="cursor_type_buffet" @click="openDetail(food_search_detail.id)">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <div>{{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} <span class="description_type_buffet">( {{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} )</span></div>
                                            <div class="description_type_buffet">
                                                {{ food_search_detail.sub_title }}
                                            </div>
                                        </div>
                                        <div>{{ Intl.NumberFormat().format(food_search_detail.price_buffet) }} ฿</div>
                                    </div>
                                    <div class="img_type_buffet">
                                        <img :src="food_search_detail.picture">
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="key_search_detail != Object.keys(buffet_select_list).length - 1"></v-divider>
                        </div>
                        <div class="mb-2 pa-3" style="background:#eee" v-if="food_search_detail.status == 0">
                            <div class="cursor_type_buffet">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <h4 class="itemout_type_buffet">ขออภัยสินค้าหมด</h4>
                                            <div>{{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} <span class="description_type_buffet">( {{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} )</span></div>
                                            <div class="description_type_buffet">
                                                {{ food_search_detail.sub_title }}
                                            </div>
                                        </div>
                                        <div>{{ Intl.NumberFormat().format(food_search_detail.price_buffet) }} ฿</div>
                                    </div>
                                    <div class="img_type_buffet">
                                        <img :src="food_search_detail.picture">
                                        <div class="img_sole_type_buffet">
                                            <img src="@/assets/soulout.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="key_search_detail != Object.keys(buffet_select_list).length - 1"></v-divider>
                        </div>
                    </div>
                </v-card>
            </div>
            <div class="px-1 mb-2 d-flex align-center" v-if="buffet_id">
                <div class="d-flex align-center cursor_type_buffet" @click="buffetSelectBackPage()">
                    <v-icon size="30">mdi-arrow-left-bold-circle</v-icon>
                    <div class="ml-1">ย้อนกลับ</div>
                </div>
            </div>
            <div v-if="buffet_id">
                <v-card class="mb-5" v-if="buffet_select_list.menuList.length > 0">
                    <h3 class="pa-3 text-center">
                        {{ buffet_select_list.name }}
                    </h3>
                    <div v-for="(food_select_detail,key_detail) in buffet_select_list.menuList" :key="key_detail">
                        <div class="mb-2 pa-3" v-if="food_select_detail.status == 1">
                            <div class="cursor_type_buffet" @click="openDetail(food_select_detail.id)">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <div>{{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} <span class="description_type_buffet">( {{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} )</span></div>
                                            <div class="description_type_buffet">
                                                {{ food_select_detail.sub_title }}
                                            </div>
                                        </div>
                                        <div>{{ Intl.NumberFormat().format(food_select_detail.price_buffet) }} ฿</div>
                                    </div>
                                    <div class="img_type_buffet">
                                        <img :src="food_select_detail.picture">
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="key_detail != Object.keys(buffet_select_list.menuList).length - 1"></v-divider>
                        </div>
                        <div class="mb-2 pa-3" style="background:#eee" v-if="food_select_detail.status == 0">
                            <div class="cursor_type_buffet">
                                <div class="d-flex justify-space-between">
                                    <div class="d-flex flex-column justify-space-between size_title_type_buffet">
                                        <div>
                                            <h4 class="itemout_type_buffet">ขออภัยสินค้าหมด</h4>
                                            <div>{{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} <span class="description_type_buffet">( {{ locale == 'en' ? food_search_detail.nameEng : food_search_detail.name }} )</span></div>
                                            <div class="description_type_buffet">
                                                {{ food_select_detail.sub_title }}
                                            </div>
                                        </div>
                                        <div>{{ Intl.NumberFormat().format(food_select_detail.price_buffet) }} ฿</div>
                                    </div>
                                    <div class="img_type_buffet">
                                        <img :src="food_select_detail.picture">
                                        <div class="img_sole_type_buffet">
                                            <img src="@/assets/soulout.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="key_detail != Object.keys(buffet_select_list.menuList).length - 1"></v-divider>
                        </div>
                    </div>
                </v-card>
            </div>

        </div>
    </div>
    <AddToppingMenu />
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/fast-food.png";
import AddToppingMenu from '@/components/menuuser/addmenu/AddToppingMenu.vue'
export default {
    components: {
        AddToppingMenu
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            border_color: '#038cc1',
            food_image: before_image,
            search: '',
            buffet_list: [],
            buffet_id: null,
            buffet_select_list: [],
            buffet_search_default_list: [],
            buffet_search_list: [],
            setting_type_food: 0,
        }
    },
    methods: {
        async searchMenu(){
           this.buffet_search_list = this.buffet_search_default_list.filter(detail => detail.name.toLowerCase().indexOf(this.search) > -1);
        },
        async buffetList() {
            this.buffet_list = []
            this.buffet_search_default_list = []
            this.buffet_search_list = []
            if (this.$route.name == 'buffetUser') {
                let ragne_id = null
                await HTTP.get('/customer/open-buffet/' + this.$route.params.id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                       ragne_id =  response.data.opentable_detail.ragne_id
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/thankyouuser')
                    }

                })

                await HTTP.get('/customer/buffet-menu-list?ragne_id='+ragne_id, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            response.data.listBuffet.forEach((detail) => {
                                if (detail.menuList.length > 0) {
                                    let image_item = detail.menuList[0]
                                    this.buffet_list.push({
                                        id:detail.id,
                                        cover_image: !image_item.picture ? this.food_image : image_item.picture,
                                        name:detail.name,
                                        menuList:detail.menuList,
                                    })
                                    this.buffet_search_default_list.push(detail.menuList)
                                }
                            })
                            this.buffet_search_default_list = this.buffet_search_default_list.flat()
                            this.loading_page = false
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async openDetail(id) {
            const dataList = {
                id: id,
                type: 0
            }
            this.$root.$emit('getDetail', dataList)
        },
        async buffetSelectPage(id){
            this.buffet_id = id
            this.buffet_select_list = this.buffet_list.find((detail) => detail.id == this.buffet_id)
        },
        async buffetSelectBackPage(){
            this.buffet_id = null
            this.buffet_select_list = []
        },
    },
    created(){
        HTTP.get('/showColor')
            .then((response) => {
                if (response.data.successful === true) {
                    this.border_color = response.data.color_code
                    this.setting_type_food = response.data.setting_type_food
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$router.push('/nametakeoutuser')
                }
        })
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.cursor_type_buffet {
    cursor: pointer;
}

.cover_image_type_buffet {
    display: flex;
    justify-content: center;
    height: 130px;
    width: 100%;
    border-radius: 20%;
    overflow: hidden;
    position: relative;
}

.cover_image_type_buffet>img {
    max-width: 100%;
}

.size_title_type_buffet {
    font-size: 18px;
    width: 50%;
}

.description_type_buffet {
    font-size: 14px;
    color: #696969;
}

.img_type_buffet {
    position: relative;
    width: 150px;
}

.img_type_buffet>img {
    max-width: 100%;
}

.itemout_type_buffet {
    color: red;
}

.img_sole_type_buffet {
    width: 85px;
    position: absolute;
    top: 0;
}

.img_sole_type_buffet>img {
    max-width: 100%;
}
</style>
